"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "title2ClassNames", {
    enumerable: true,
    get: function() {
        return _useTitle2Stylesstyles.title2ClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Title2"), exports);
const _useTitle2Stylesstyles = require("./useTitle2Styles.styles");
